import { findDraggingPlaceholderElement } from './findDraggingPlaceholderElement';

export const buildDraggingPlaceholderElement = (
  droppableElement: HTMLElement,
  draggingElement: HTMLElement,
  draggableId: string,
): HTMLElement => {
  const elem = findDraggingPlaceholderElement(droppableElement, draggableId);
  if (elem) return elem;

  const placeholderElement = document.createElement('div');
  placeholderElement.classList.add('draggingPlaceholder');
  placeholderElement.setAttribute('data-draggableplhid', draggableId);

  // set placeholder style
  const draggingStyle = window.getComputedStyle(draggingElement);
  placeholderElement.style.height = draggingStyle.height;
  placeholderElement.style.width = '100%';

  droppableElement.appendChild(placeholderElement);
  return placeholderElement;
};
